import { IFooterLinkWithIcon } from '@interfaces/IFooter';
import React from 'react';
import { LocaleConfigContext } from '../../../../contexts/locale-config/locale-config';
import { portal } from '../../../../utils/locale';
import { __ } from '../../../../utils/translation-service';
import { isNewsletterSubmitCookie } from './cookie';
import { NewsletterForm } from './NewsletterForm';
import { checkElementInViewport } from './scrollHelpers';

interface IUserActionProps extends IFooterLinkWithIcon {
    className?: string;
    targetUrl: string;
}

interface IState {
    hide: boolean;
    footerGetInContactFix: boolean;
    footerGetInContactTabHideIcons: boolean;
    footerGetInContactFixOpen: boolean;
}

export class UserAction extends React.Component<IUserActionProps, {}> {
    public render() {
        return (
            <div className={this.props.className}>
                <a className="pull-left" href={this.props.targetUrl} title={this.props.linkTitle}>
                    <div
                        className={`pull-left ${this.props.iconClass ? this.props.iconClass : ''}`}
                    />
                    <div className="pull-left">
                        <p>{this.props.title}</p>
                    </div>
                </a>
            </div>
        );
    }
}

export class AdvisorLink extends React.Component<IUserActionProps, {}> {
    public render() {
        return (
            <div className="col-xs-12 col-sm-3">
                <a
                    className="footer_getInContact_advisor pull-left"
                    href={this.props.targetUrl}
                    title={this.props.linkTitle}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <span className="footer_getInContact_advisorImage" />
                    <div className="pull-left">
                        <p>{this.props.title}</p>
                    </div>
                </a>
            </div>
        );
    }
}

export class FooterContactForm extends React.Component<{ phoneNumber?: string }, IState> {
    public state = {
        hide: true,
        footerGetInContactFix: false,
        footerGetInContactTabHideIcons: false,
        footerGetInContactFixOpen: false,
    };

    public element: HTMLDivElement | undefined;

    public listenToScrollContactTag = () => {
        if (this.element && checkElementInViewport(this.element)) {
            this.setState({
                footerGetInContactFix: false,
                footerGetInContactTabHideIcons: true,
                footerGetInContactFixOpen: false,
            });
        } else {
            this.setState({
                footerGetInContactFix: true,
                footerGetInContactTabHideIcons: false,
            });
        }
    };

    public contactContainerRef = (element: HTMLDivElement) => {
        if (element) {
            this.element = element;
        }
    };

    public componentDidMount() {
        this.setState({
            hide: isNewsletterSubmitCookie(),
        });
        this.listenToScrollContactTag();
        window.addEventListener('scroll', this.listenToScrollContactTag);
    }

    public componentWillUnmount() {
        window.removeEventListener('scroll', this.listenToScrollContactTag);
    }

    public openContactTagContent = () => {
        if (this.state.footerGetInContactFix) {
            this.setState({
                footerGetInContactFixOpen: !this.state.footerGetInContactFixOpen,
            });
        }
    };

    public render() {
        const {
            footerGetInContactFix,
            footerGetInContactFixOpen,
            footerGetInContactTabHideIcons,
        } = this.state;
        return (
            <LocaleConfigContext.Consumer>
                {(localeConfig) => (
                    <div id="footer_getInContact_switch" ref={this.contactContainerRef}>
                        <div
                            className={`footer_getInContact ${
                                footerGetInContactFix ? 'footer_getInContact-fix' : ''
                            } ${footerGetInContactFixOpen ? 'footer_getInContact-fix-open' : ''} `}
                        >
                            <div
                                className={`footer_getInContact_tab ${
                                    footerGetInContactTabHideIcons
                                        ? 'footer_getInContact_tab-hideIcons'
                                        : ''
                                }`}
                                onClick={this.openContactTagContent}
                                role="presentation"
                            >
                                {__('contact')}
                                <span className="footer_getInContact_tab_icon icon-arrowTop" />
                                <span className="footer_getInContact_tab_icon icon-arrowDown" />
                            </div>
                            <div className="footer_getInContact_content container">
                                <div
                                    className={
                                        'footer_getInContact_userActions' +
                                        (this.state.hide
                                            ? ' footer_getInContact_userActions_hide'
                                            : '')
                                    }
                                >
                                    <div className="col-xs-12 col-sm-6 col-md-3">
                                        <div className="icon-handset-rounded pull-left" />

                                        <div className="pull-left">
                                            <p>{__('freeHotline')}</p>
                                            <strong
                                                dangerouslySetInnerHTML={{
                                                    __html: this.props.phoneNumber || '',
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-sm-6 col-md-3">
                                        <a
                                            className="pull-left"
                                            href={`mailto:${__('infoEmail')}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <div className="icon-email pull-left" />

                                            <div className="pull-left footer_getInContact_userActions_action">
                                                <p>{__('writeUsAnEmail')}</p>
                                            </div>
                                        </a>
                                    </div>

                                    <div className="col-xs-12 col-sm-6 col-md-3">
                                        <a
                                            className="pull-left"
                                            href={`https://www.${localeConfig.url}/faq`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <div className="icon-faq pull-left" />

                                            <div className="pull-left footer_getInContact_userActions_action">
                                                <p>{__('readFAQAndAnswers')}</p>
                                            </div>
                                        </a>
                                    </div>

                                    <div className="col-xs-12 col-sm-6 col-md-3">
                                        <a
                                            className="footer_getInContact_advisor pull-left"
                                            href={`https://www.${localeConfig.url}/${localeConfig.slugs.contact}`}
                                            title=""
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <span
                                                className={`footer_getInContact_advisorImage footer_getInContact_advisorImage_${portal}`}
                                            />

                                            <div className="pull-left footer_getInContact_userActions_action">
                                                <p>{__('contactYourExperts')}</p>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                {this.state.hide ? null : (
                                    <div className="row footer_getInContact_newsletter">
                                        <strong
                                            className="col-xs-12 col-sm-7 col-md-6"
                                            dangerouslySetInnerHTML={{
                                                __html: `${__('subscribeNewsletter')} & ${__(
                                                    'saveUpToBoardCredit',
                                                )}`,
                                            }}
                                        />
                                        <NewsletterForm />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </LocaleConfigContext.Consumer>
        );
    }
}
